<template>
  <div ref="footer" :class="['footer']">
    <div class="fixed-forgrid">
      <footer>
        <div class="footer-content">
          <b-link class="contact-item contact-item-logo" v-if="logoUrl !== undefined" :to="navLinkPrefix + '/'">
            <img class="converter-footer-logo" :src="host + logoUrl" :alt="'QazLatyn'">
          </b-link>
          <span class="item-divider">|</span>
          <span class="contact-item">
            {{ address }}
          </span>
          <span class="item-divider">|</span>
          <span class="contact-item">
            <a class="contact-item-link" :href="'tel:+' + phone">{{ phone }}</a>
          </span>
          <span class="item-divider">|</span>
          <span class="contact-item">
            <a class="contact-item-link" :href="'mailto:' + email">{{ email }}</a>
          </span>
          <span class="item-divider">|</span>
          <span class="contact-item converter-operating-instructions">
              <strong @click="showOIsModal">{{ ls_OperatingInstructions }}</strong>
          </span>
        </div>
        <hr>
        <div class="copyright">
          <span v-html="copyright"></span>
          <span class="float-right contact-item"><strong>{{ ls_ReportError }}</strong> {{ ls_ReportErrorDescription }}</span>
        </div>
      </footer>
    </div>
    <b-modal ref="oisModal" size="lg" @show="playOIsVedio" @hide="pauseOIsVedio" hide-footer :title="ls_OperatingInstructions">
      <div class="d-block text-center video-container">
        <video ref="oisVedio" class="video" src="https://www.qazlatyn.kz/uploads/video/usingconverter.mp4" controls="controls">
          This browser is not support video!
        </video>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      footerPosition: "position-static",
      navLinks: []
    };
  },

  computed: {
    host() {
      return this.$store.state.host;
    },
    ls_OperatingInstructions() {
      return this.$store.state.languagePack.ls_OperatingInstructions;
    },
    ls_ReportError() {
      return this.$store.state.languagePack.ls_ReportError;
    },
    ls_ReportErrorDescription() {
      return this.$store.state.languagePack.ls_ReportErrorDescription;
    },
    facebook() {
      return this.$store.state.siteSettings.facebook;
    },
    instagram() {
      return this.$store.state.siteSettings.instagram;
    },
    youtube() {
      return this.$store.state.siteSettings.youtube;
    },
    vk() {
      return this.$store.state.siteSettings.vk;
    },
    twitter() {
      return this.$store.state.siteSettings.twitter;
    },
    telegram() {
      return this.$store.state.siteSettings.telegram;
    },
    email() {
      return this.$store.state.siteSettings.email;
    },
    phone() {
      return this.$store.state.siteSettings.phone;
    },
    address() {
      return this.$store.state.siteSettings.address;
    },
    copyright() {
      return this.$store.state.siteSettings.copyright;
    },
    logoUrl() {
      return this.$store.state.siteSettings.pcLogo;
    },
    navLinkPrefix() {
      return this.$route.params.ln !== undefined
        ? "/" + this.$route.params.ln
        : "";
    },

    routePath() {
      return this.$route.params.ln !== undefined
        ? this.$route.path.substring(
            this.$route.path.substring(1).indexOf("/") + 1
          )
        : this.$route.path;
    }
  },

  methods: {
    showOIsModal() {
      this.$refs.oisModal.show();
    },
    playOIsVedio() {
      let video = this.$refs.oisVedio;
      if (!video) return;
      video.addEventListener(
        "load",
          function() {
            video.play();
          },
          false
      );
      video.pause();
      video.play();
    },
    pauseOIsVedio() {
      let video = this.$refs.oisVedio;
      if (!video) return;
      video.pause();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/styles/common.scss";

.footer {
  position: absolute;
  background-color: #f2f2f2;
  right: 0;
  bottom: 0;
  left: 0;

  hr {
    margin: 0 15px !important;
  }

  .footer-content {
    display: inline-flex;
    color: #ced0d2;
    padding: 20px;

    .item-divider {
      font-size: 18px;
      margin-top: -4px;
    }

    .contact-item.contact-item-logo {
      filter: grayscale(100%);
      margin-left: 0;
      transition: all 0.3s ease-in-out;

      &:hover {
        filter: grayscale(50%);
        transform: scale(1.05, 1.05);
      }
    }
  }

  .converter-operating-instructions > strong {
    color: #008490 !important;
    cursor: pointer;
  }

  .contact-item {
    margin: 0 16px;
    font-size: 14px;
    color: #6c6d70;
    font-family: Arial, Helvetica, sans-serif;

    strong {
      color: #212525;
    }

    .converter-footer-logo {
      height: 22px;
    }
    .contact-item-link {
      color: #6c6d70 !important;
    }
  }

  .copyright {
    padding: 9px 15px;
    font-size: 12px;
    color: #a6a9ab;
    font-family: Arial, Helvetica, sans-serif;
  }
}
.video-container {
  margin: -15px;

  .video {
    max-width: 100%;
  }
}
.rtl-layout {
  footer {
    direction: rtl;
    text-align: right;
  }

  .footer-content {
    direction: rtl;
    text-align: right;
  }

  .contact-item {
    direction: rtl;
    text-align: right;
  }

  .contact-item.contact-item-logo {
    margin-left: 16px !important;
    margin-right: 0 !important;
  }

  .copyright {
    direction: rtl;
    text-align: right;
  }
}
</style>
